import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ResourcesTabParamList, useGoBack, useResourcesTabNavigation } from '../../../../../utils/appNavigationNames';
import useNotes from '../../../../../hooks/api/useNotes';
import NoteDetails from '../../../../shared/Notes/NoteDetails';
import { getIntl } from '../../../../../utils/intl';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';

const intl = getIntl('notes-details', {
    transferNote: 'Move Note',
    delete: 'Delete Note',
});

export type NoteDetailsScreenOwnProps = {};

export type NoteDetailsScreenProps = NoteDetailsScreenOwnProps & {
    route: RouteProp<ResourcesTabParamList, 'note'>;
};

const NoteDetailsScreen: React.FC<NoteDetailsScreenProps> = (props) => {
    const goBack = useGoBack();
    const navigator = useResourcesTabNavigation();
    const { isLoading, note, deleteNote, isDeletingNote } = useNotes({
        noteId: props.route.params.noteId,
        onNoteLoadFailure: () => {
            goBack();
        },
    });

    return (
        <AnimateLoadedContent isLoading={isDeletingNote || isLoading || !note}>
            {() =>
                note ? (
                    <NoteDetails
                        note={note}
                        canEdit={!isDeletingNote && !note.isSystemGenerated}
                        onEdit={() => {
                            navigator.navigate('edit-note', {
                                noteId: note.noteId,
                            });
                        }}
                        editActions={[
                            {
                                icon: 'Trash2',
                                title: intl('delete'),
                                onPress: () => {
                                    deleteNote(props.route.params.noteId);
                                    goBack();
                                },
                                isDisabled: isDeletingNote,
                                testID: 'delete-note-button',
                            },
                        ]}
                        disableComments
                    />
                ) : null
            }
        </AnimateLoadedContent>
    );
};

export default React.memo(NoteDetailsScreen);
